import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  StyledParagraphBold,
  TextWrapper,
  StyledFormControl,
  StyledSelect,
} from "../FuiStyles";
import {
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Divider,
  InputLabel,
} from "@material-ui/core";
import * as FormField from "./IndividualFormFields";
import { BorderlessButton } from "../../common/CommonComponents/Buttons";
import { appNameProjectId } from "../Constants/ProductIds";
 
import * as PlatformFormField from "./IndividualFormFields";
import * as fuiRedux from "../../../redux/fui/index";

const BundleOrderApps = ({
  classes,
  updateSPLUCLUForm,
  handleChange,
  config,
  values,
  res,
  updateForm,
  isMonthlyTicketVolumeValid,
  formName,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [selectedDropdown, setSelectedDropdown] = useState("");

  const handleShowPassword = () => {
    if (showPassword) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  };

  const handleCheckBoxChange = (fieldName) => {
    const valueInArray =
      values.StackApplication.filter((addon) => addon === `${fieldName}`)
        .length > 0;
    if (valueInArray) {
      let removedFromArray = values.StackApplication.filter(
        (addon) => addon !== `${fieldName}`
      );
      //console.log(removedFromArray)
      removedFromArray.sort();
      if (removedFromArray[0] == removedFromArray[removedFromArray.length - 1]) {
        removedFromArray = removedFromArray.filter(
          (addon) => addon !== "acn-alertcentre360"
        );
      }
      {/* if (
        fieldName === "acn-infra360host-addons-detailed-windows" ||
        fieldName === "acn-infra360host-addons-detailed-linux" ||
        fieldName === "acn-infra360host-ping" ||
        fieldName === "acn-hostprocess360-linux" ||
        fieldName === "acn-infra360host" ||
        fieldName === "acn-db360-oracledb" ||
        fieldName === "acn-db360-mssqlserver" ||
        fieldName === "acn-db360-mysql" ||
        fieldName === "acn-infra360host-addons-windows" ||
        fieldName === "acn-hostprocess360-windows" ||
        fieldName === "acn-hostservice360-services" ||
        fieldName === "acn-infra360snmp-traps" ||
        fieldName === "acn-infra360nnmi" ||
        fieldName === "acn-infra360solarwinds" ||
        fieldName === "acn-cloud360-addons-aws" ||
        fieldName === "acn-cloud360-addons-azure" ||
        fieldName === "acn-db360-postgresql" ||
        fieldName === "acn-url360-api"
      ) {
        removedFromArray = removedFromArray.filter(
          (addon) => addon !== "acn-alertcentre360"
        );
        console.log(removedFromArray);
      } */}
      if (
        fieldName === "acn-infra360host-addons-detailed-windows" ||
        fieldName === "acn-infra360host-addons-detailed-linux"
      ) {
        removedFromArray = removedFromArray.filter(
          (addon) => addon !== "acn-infra360host"
        );
        removedFromArray = removedFromArray.filter(
          (addon) => addon !== "acn-alertcentre360"
        );
      }
      updateSPLUCLUForm("StackApplication", removedFromArray);
    } else if (
      fieldName === "acn-infra360host-addons-detailed-windows" ||
      fieldName === "acn-infra360host-addons-detailed-linux"
    ) {
      updateSPLUCLUForm("StackApplication", [
        ...values.StackApplication,
        `${fieldName}`,
        "acn-infra360host", "acn-alertcentre360",
      ]);
    } else {
      updateSPLUCLUForm("StackApplication", [
        ...values.StackApplication,
        `${fieldName}`,
        "acn-alertcentre360",
      ]);
    }
  };

  const [displayCheckboxes, setDisplayCheckboxes] = useState(false);
  const [displayRadioButtons, setDisplayRadioButtons] = useState({
    GenCluster: false,
    ticketAnalysis: false,
    ticketAnalysisForManaged: false,
    sharepoint: false,
    devOpsAnalytics: false,
    reportExtractor: false,
    stormwatch: false,
    stack: false,
  });

  useEffect(() => {
    const res = [];

    // Include only the selected dropdown in payload
    if (selectedDropdown === "TAwithGenCluster") {
      res.push(appNameProjectId.ticketAnalysisId); // Only TA part
    } else if (selectedDropdown === "TAonly") {
      res.push(appNameProjectId.ticketAnalysisId);
    } else if (selectedDropdown === "GenCluster") {
      res.push(appNameProjectId.ticketAnalysisId); // GenCluster also uses TA ID
    }

    displayRadioButtons.sharepoint && res.push(appNameProjectId.sharepointAddOnId);
    displayRadioButtons.devOpsAnalytics && res.push(appNameProjectId.devOpsAnalyticsId);
    displayRadioButtons.reportExtractor && res.push(appNameProjectId.reportExtractorAddOnId);
     displayRadioButtons.stack &&
      res.push(appNameProjectId.stack360Id);
    displayRadioButtons.stormwatch && res.push(appNameProjectId.stormwatchId);
    displayRadioButtons.stack && res.push(appNameProjectId.stack360Id);
    updateForm("appProductUId", res);
    updateForm("bundledProv", selectedDropdown !== "");
  }, [selectedDropdown, displayRadioButtons]);

  const handleRadioButtonChange = (event) => {
    setDisplayRadioButtons({
      ...displayRadioButtons,
      [event.target.name]: event.target.checked,
    });
  };

  const {
    ticketAnalysis,
    ticketAnalysisForManaged,
    sharepoint,
    devOpsAnalytics,
    reportExtractor,
    stormwatch,
    stack,
    GenCluster,
  } = displayRadioButtons;

  // DevOps specific states
  const [PlanAndScope, setPlanAndScope] = useState("");
  const [SourceManagement, setSourceManagement] = useState("");
  const [
    BuildAndDeploymentManagement,
    setBuildAndDeploymentManagement,
  ] = useState("");
  const [QualityManagement, setQualityManagement] = useState("");
  const [ServiceManagement, setServiceManagement] = useState("");
  const [DevSecOps, setDevSecOps] = useState("");

  const arr = new Array([]);
  PlanAndScope !== "" && arr.push(PlanAndScope);
  SourceManagement !== "" && arr.push(SourceManagement);
  BuildAndDeploymentManagement !== "" && arr.push(BuildAndDeploymentManagement);
  QualityManagement !== "" && arr.push(QualityManagement);
  DevSecOps !== "" && arr.push(DevSecOps);
  ServiceManagement !== "" && arr.push(ServiceManagement);

  const [isJiraSelectedByPlan, setIsJiraSelectedByPlan] = useState(false);
  const [isJiraSelectedByService, setIsJiraSelectedByService] = useState(false);

  const handleChangePlanAndScope = (event) => {
    setPlanAndScope(event.target.value);
    if (event.target.value === "Jira") {
      setIsJiraSelectedByPlan(true);
    }
    if (event.target.value !== "Jira") {
      setIsJiraSelectedByPlan(false);
    }
  };

  const handleChangeSourceManagement = (event) => {
    setSourceManagement(event.target.value);
  };
  const handleChangeBuildAndDeploymentManagement = (event) => {
    setBuildAndDeploymentManagement(event.target.value);
  };
  const handleChangeQualityManagement = (event) => {
    setQualityManagement(event.target.value);
  };
  const handleChangeServiceManagement = (event) => {
    setServiceManagement(event.target.value);
    if (event.target.value === "Jira") {
      setIsJiraSelectedByService(true);
    }
    if (event.target.value !== "Jira") {
      setIsJiraSelectedByService(false);
    }
  };

  const handleChangeDevSecOps = (event) => {
    setDevSecOps(event.target.value);
  };

  const DevOpsAddonsGroup = arr.join(",");

  useEffect(() => {
    updateForm("DevOpsAddonsGroup", DevOpsAddonsGroup);
  }, [arr]);

  return (
    <div style={{ float: "left", alignItems: "flex-start" }}>
      <BorderlessButton
        label={(displayCheckboxes ? "-" : "+") + " Configure Splunk Application"}
        className={classes.FuiBorderlessButton}
        onClick={() => {
          if (displayCheckboxes) {
            setSelectedDropdown("");
            updateForm("TAapps", ""); // Clear TAapps when collapsing
            updateForm("TicketFeed", ""); // Also clear TicketFeed
            updateForm("TicketMonthlyVolume", ""); // Clear related fields
          }
          setDisplayCheckboxes(!displayCheckboxes);
        }}
      />

      {displayCheckboxes && (
        <StyledFormControl variant="outlined" margin="dense" style={{ minWidth: 250, marginTop: 10 }}>
          <InputLabel htmlFor="outlined-configure-splunk">
            Configure Splunk Application
          </InputLabel>
          <StyledSelect
            value={selectedDropdown}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedDropdown(value);

              // Update state to show correct fields
              setDisplayRadioButtons({
                GenCluster: value === "GenCluster",
                ticketAnalysis: value === "TAwithGenCluster",
                ticketAnalysisOnly: value === "TAonly",
                ticketAnalysisForManaged: false,
                sharepoint: false,
                devOpsAnalytics: false,
                reportExtractor: false,
                stormwatch: false,
                stack: false,
              });
              updateForm("TAapps", value);
            }}
            label="Configure Splunk Application"
            inputProps={{ id: "outlined-configure-splunk" }}
          >
            <MenuItem value="">
              <em>--Select Option--</em>
            </MenuItem>
            <MenuItem value="TAwithGenCluster">Ticket Analysis with GenCluster</MenuItem>
            <MenuItem value="TAonly">Ticket Analysis</MenuItem>
            <MenuItem value="GenCluster">GenCluster</MenuItem>
          </StyledSelect>
        </StyledFormControl>
      )}

      {/* Ticket Analysis Fields */}
      {
        displayCheckboxes && (selectedDropdown === "TAwithGenCluster" || selectedDropdown === "TAonly" || selectedDropdown === "GenCluster") && (
          <div style={{ marginTop: "10px", width: "100%" }}>
            {FormField.TicketFeedMethodField(handleChange, values)}
            {/* {values.TicketFeed === "availbleOverServiceNowAPI" && FormField.ServiceNowURlField(handleChange, values)}
            {values.TicketFeed === "availbleOverServiceNowAPI" && FormField.ServiceNowUsernameField(handleChange, values)}
            {values.TicketFeed === "availbleOverServiceNowAPI" &&
              FormField.ServiceNowPasswordField(handleChange, values, showPassword, handleShowPassword)} */}
            {FormField.MonthlyTicketVolumeField(handleChange, values, isMonthlyTicketVolumeValid)}
          </div>
        )
      }

      {displayRadioButtons.sharepoint && (
        <div>
          <TextWrapper>
            <StyledParagraphBold>Sharepoint Details:</StyledParagraphBold>
          </TextWrapper>
          Nothing additional to fill out here
        </div>
      )}
      {displayRadioButtons.devOpsAnalytics && (
        <div>
          <TextWrapper>
            <StyledParagraphBold>DevOps Details:</StyledParagraphBold>
          </TextWrapper>
          {FormField.PlanAndScopeField(
            handleChangePlanAndScope,
            PlanAndScope,
            isJiraSelectedByService,
            SourceManagement !== "Webservice" &&
            BuildAndDeploymentManagement !== "Webservice" &&
            QualityManagement !== "Webservice" &&
            ServiceManagement !== "Webservice"
          )}

          {FormField.SourceManagementField(
            handleChangeSourceManagement,
            SourceManagement,
            PlanAndScope !== "Webservice" &&
            BuildAndDeploymentManagement !== "Webservice" &&
            QualityManagement !== "Webservice" &&
            ServiceManagement !== "Webservice"
          )}

          {FormField.BuildAndDeploymentField(
            handleChangeBuildAndDeploymentManagement,
            BuildAndDeploymentManagement,
            SourceManagement !== "Webservice" &&
            PlanAndScope !== "Webservice" &&
            QualityManagement !== "Webservice" &&
            ServiceManagement !== "Webservice"
          )}

          {FormField.QualityManagementField(
            handleChangeQualityManagement,
            QualityManagement,
            SourceManagement !== "Webservice" &&
            BuildAndDeploymentManagement !== "Webservice" &&
            PlanAndScope !== "Webservice" &&
            ServiceManagement !== "Webservice"
          )}

          {FormField.ServiceManagementField(
            handleChangeServiceManagement,
            ServiceManagement,
            isJiraSelectedByPlan,
            SourceManagement !== "Webservice" &&
            BuildAndDeploymentManagement !== "Webservice" &&
            QualityManagement !== "Webservice" &&
            PlanAndScope !== "Webservice"
          )}

          {/* {FormField.DevSecOpsField(handleChangeDevSecOps, DevSecOps)} */}
        </div>
      )}
      {displayRadioButtons.reportExtractor && (
        <div>
          <TextWrapper>
            <StyledParagraphBold>Report Extractor Details:</StyledParagraphBold>
          </TextWrapper>
          Nothing additional to fill out here
        </div>
      )}
      {displayRadioButtons.stormwatch && (
        <div>
          <TextWrapper>
            <StyledParagraphBold>Stormwatch Details:</StyledParagraphBold>
          </TextWrapper>
          Nothing additional to fill out here
        </div>
      )}
      {displayRadioButtons.stack && (
        <div>
          <TextWrapper>
            <StyledParagraphBold>List of Stack Applications:</StyledParagraphBold>
          </TextWrapper>
          <StyledParagraphBold>OS Monitoring</StyledParagraphBold>

          <Divider />

          {PlatformFormField.Infra360HostDetailedLinuxCheckbox(
            values,
            handleCheckBoxChange
          )}


          {PlatformFormField.HostProcess360LinuxCheckbox(
            values,
            handleCheckBoxChange
          )}


          {PlatformFormField.Infra360HostCheckbox(
            values,
            handleCheckBoxChange
          )}

          <StyledParagraphBold>DB Monitoring</StyledParagraphBold>

          <Divider />

          {PlatformFormField.DB360OracleDBCheckbox(
            values,
            handleCheckBoxChange
          )}

          {PlatformFormField.DB360MSSQLServerCheckbox(
            values,
            handleCheckBoxChange
          )}

          {PlatformFormField.DB360MYSQLCheckbox(
            values,
            handleCheckBoxChange
          )}

          <StyledParagraphBold>VM Monitoring</StyledParagraphBold>

          <Divider />

          {PlatformFormField.Infra360HostDetailedWindowsCheckbox(
            values,
            handleCheckBoxChange
          )}

          {PlatformFormField.HostProcessWindowsCheckbox(
            values,
            handleCheckBoxChange
          )}

          {PlatformFormField.HostService360Checkbox(
            values,
            handleCheckBoxChange
          )}

          <StyledParagraphBold>Host Ping</StyledParagraphBold>

            <Divider />

          {PlatformFormField.HostPingCheckbox(
            values,
            handleCheckBoxChange
          )}

          <StyledParagraphBold>Hardware Monitoring</StyledParagraphBold>

          <Divider />

          {PlatformFormField.Infra360SNMPTrapsCheckbox(
            values,
            handleCheckBoxChange
          )}



          <StyledParagraphBold>Alerting</StyledParagraphBold>

            <Divider />

            {PlatformFormField.AlertCentreCheckbox(values, handleCheckBoxChange)}

            <StyledParagraphBold>Network Monitoring</StyledParagraphBold>

            <Divider />

            {PlatformFormField.Infra360NNMiCheckbox(values, handleCheckBoxChange)}

            {PlatformFormField.Infra360SolarWindsCheckbox(
              values,
              handleCheckBoxChange
            )}

            <StyledParagraphBold>Cloud Monitoring</StyledParagraphBold>

            <Divider />

            {PlatformFormField.Cloud360AWSCheckbox(values, handleCheckBoxChange)}

            {PlatformFormField.Cloud360AzureCheckbox(
              values,
              handleCheckBoxChange
            )}

            <StyledParagraphBold>DB360 Postgre SQL</StyledParagraphBold>

            <Divider />

            {PlatformFormField.DB360PostgresSQLCheckbox(
              values,
              handleCheckBoxChange
            )}

            <StyledParagraphBold>URL Monitoring</StyledParagraphBold>

            <Divider />

            {PlatformFormField.URL360APICheckbox(values, handleCheckBoxChange)}
          </div>
        )
      }
    </div >
  );
};
const MSTP = (state, ownProps) => ({
  dpState: state.fui.DPForm,
  values: ownProps.values || state.fui.SPLUCLUForm, // Use parent's values if provided
  isRootExist: state.fui.isRootExist,
  configurationType: state.fui.configurationType,
});

export default connect(MSTP, {
  updateSPLUCLUForm: fuiRedux.updateSPLUCLUForm,
  updateASelectedInstanceByField: fuiRedux.updateASelectedInstanceByField,
  checkDomainAvaliable: fuiRedux.checkRootExisted,
})(withRouter(BundleOrderApps));
